import { Label as LabelDs, Typography } from "@packages/ds";
import styled from "styled-components";

import InputDs from "ds/Input";
import BodyFooterLayout from "src/root/pages/components/BodyFooterLayout";
import Button from "src/root/pages/components/Button";
import LeftPanel from "src/root/pages/components/LeftPane";
import Separator from "src/root/pages/components/Separator";
import SocialBtn from "src/root/pages/components/socials/button";
import SplitLayout from "src/root/pages/components/SplitLayout";
import Text from "src/root/pages/components/Text";
import Title from "src/root/pages/components/Title";
import { calcColumnWidth } from "src/root/pages/utils/layout";

export const RequiredCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RightPaneLayout = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  justify-content: center;
`;

export const Container = styled.div`
  max-width: 350px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 40px;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  & > div {
    width: 100%;
    text-align: left;
  }

  input {
    width: 100%;
  }
`;

export const BodyText = styled(Typography.BodyText)`
  display: inline-block;
  grid-template-columns: 1fr max-content;
`;

export const Label = styled(LabelDs)`
  margin-bottom: 0px;
`;

export const RequiredLabel = styled(LabelDs)`
  display: inline-block;
  align-items: center;
  margin: auto 0px;
`;

export const LeftPane = styled(LeftPanel)`
  padding: 243px 0 0 0;
`;

export const LeftPaneTitle = styled.div`
  padding: 0 0 86px 0;
  text-align: center;
  padding-left: ${() => calcColumnWidth(2, 0, "start")};
  padding-right: ${() => calcColumnWidth(2, 0, "start")};

  img {
    width: 211px;
  }
  p {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 1280px) {
    padding-left: ${() => calcColumnWidth(1, 0, "start")};
    padding-right: ${() => calcColumnWidth(1, 0, "start")};
  }
`;

export const LeaderFall = styled.p`
  margin-top: 40px;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
`;

export const SocialButton = styled(SocialBtn)`
  position: relative;
  img {
    width: 16px;
    height: 16px;
  }
`;

export const SocialButtons = styled.div`
  display: flex;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 6px;
  }

  @media only screen and (max-width: 940px) {
    display: grid;
    grid-column-gap: 42px;
  }
`;

export const ForgetPassword = styled.div`
  font-size: 13px;
  margin-bottom: 40px;
`;

export const EmailText = styled(Text)`
  font-size: 15px;
  line-height: 33px;
  color: var(--theme-neutral-600);
  cursor: pointer;
  display: flex;
  align-items: center;

  svg {
    margin-right: 16px;
  }
`;

export const BodyLayout = styled(BodyFooterLayout)`
  @media only screen and (max-width: 1280px) {
    padding: 0;
    .seperator {
      width: 100%;
      margin: 18px 0 0 0;
    }
    input#username,
    .username-layout,
    input-password,
    .password-layout {
      width: 100%;
      max-width: 100%;
    }
    button,
    .loading-wrapper {
      max-width: 100%;
      width: 100%;
    }
  }
`;

export const LabelText = styled(Text)`
  color: var(--label-ebony-light-color, var(--ebony-light));
`;

export const TitleWrapper = styled.div`
  margin-top: 40px;

  .sm {
    display: block;
  }

  @media only screen and (min-width: 1200px) {
    .sm {
      display: none;
    }
    .lg {
      display: block;
    }
    .login-description {
      margin: 32px 0 24px 0;
    }
  }

  .login-description {
    margin-bottom: 13px;
  }

  ${Title} {
    max-width: max-content;
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  top: -20px;
  height: 0px;
  z-index: 0;
`;

export const LoginLayout = styled(SplitLayout)`
  background: #fff;
`;

export const StyledSeparator = styled(Separator)`
  margin: 32px 0;
  width: auto;
`;

export const LoginText = styled(Text)`
  margin-bottom: 20px;
`;

export const NextButton = styled(Button)`
  margin-top: 32px;
`;

export const Input = styled(InputDs)`
  margin-bottom: 8px;
  & > input {
    width: 350px;
  }
  color: var(--theme-neutral-500);
`;
